import { render, staticRenderFns } from "./SecurityQuestions.vue?vue&type=template&id=58ed7a49&"
import script from "./SecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./SecurityQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ed7a49')) {
      api.createRecord('58ed7a49', component.options)
    } else {
      api.reload('58ed7a49', component.options)
    }
    module.hot.accept("./SecurityQuestions.vue?vue&type=template&id=58ed7a49&", function () {
      api.rerender('58ed7a49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/eSign/components/SecurityQuestions.vue"
export default component.exports